module.exports = __webpack_public_path__ + "img/girl.2223da6f.png";